const SESSION_KEY = 'salesiq_visitor';

function clearVisitor() {
  sessionStorage.removeItem(SESSION_KEY);
}

function salesIqVisitorAvailable() {
  return !!window.$zoho?.salesiq?.visitor;
}

export function applyVisitor(visitor) {
  const { agentFirstName, agentLastName, agentEmail, ...rest } = visitor;

  if (!salesIqVisitorAvailable()) {
    return false;
  }

  if (!visitor) {
    return true;
  }

  if (agentEmail) {
    window.$zoho.salesiq.visitor.email(agentEmail);
  }

  if (agentFirstName && agentLastName) {
    window.$zoho.salesiq.visitor.name({
      firstname: agentFirstName,
      lastname: agentLastName
    });
  }

  window.$zoho.salesiq.visitor.info(rest);

  return true;
}

export function resetVisitor() {
  clearVisitor();

  if (typeof window.$zoho?.salesiq?.reset === 'function') {
    window.$zoho.salesiq.reset();
    if (window.$zoho?.salesiq?.floatbutton) {
      window.$zoho.salesiq.floatbutton.position('bottomleft');
    }
  }
}

export function setChatVisibility(isVisible) {
  if (typeof window.$zoho?.salesiq?.floatbutton?.visibility === 'function') {
    window.$zoho.salesiq.floatbutton.visibility(isVisible ? 'show' : 'hide');
  }
}

export function setChatPosition(position) {
  const positions = [
    'topright',
    'topleft',
    'bottomright',
    'bottomleft',
    'right',
    'left'
  ];

  if (!positions.includes(position)) {
    throw new Error(`Invalid position: ${position}`);
  }

  if (typeof window.$zoho?.salesiq?.floatbutton?.position === 'function') {
    window.$zoho.salesiq.floatbutton.position(position);
  }
}
